var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9431 4.78723C11.9999 4.65015 12.0147 4.4993 11.9857 4.35378C11.9568 4.20827 11.8853 4.07461 11.7803 3.96973L8.03034 0.219727L6.96984 1.28023L9.43959 3.74998H8.689e-05V5.24998H11.2501C11.3984 5.25001 11.5434 5.20607 11.6668 5.1237C11.7901 5.04133 11.8863 4.92424 11.9431 4.78723ZM0.0570871 7.21273C0.000308448 7.34981 -0.014535 7.50065 0.0144353 7.64617C0.0434055 7.79169 0.114888 7.92534 0.219837 8.03023L3.96984 11.7802L5.03034 10.7197L2.56059 8.24998H12.0001V6.74998H0.750087C0.60174 6.74984 0.456692 6.79374 0.333321 6.87612C0.209951 6.9585 0.113812 7.07565 0.0570871 7.21273Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer1);
export default __webpack_public_path__ + "static/media/transfer1.9765aaec6dc670dad678326b4c467af5.svg";
export { ForwardRef as ReactComponent };